<div
  class="filtro-periodo-wrapper input-filtro-selecionado"

>
  <div style="position: relative; width: 100%">
      <img
      src="{{ BASE_IMG_URL }}assets/agenda-tarefas/calender.svg"
      alt="Calendário"
      width="18"
      height="18"
      
    />
    <input
      type="text"
      bsDaterangepicker
      [(ngModel)]="intervaloSelecionado"
      [bsConfig]="config"
      (ngModelChange)="onPeriodoChange()"
      class="input-periodo"
      [placeholder]="
        intervaloSelecionado?.length === 2
          ? formatDate(intervaloSelecionado[0]) +
            ' - ' +
            formatDate(intervaloSelecionado[1])
          : 'Todos os períodos'
      "
      readonly
    
    />
  
  </div>

  <button
    *ngIf="intervaloSelecionado?.length"
    type="button"
    class="btn-clear"
    (click)="limparPeriodo()"
    style="z-index: 2"
  >
    ×
  </button>
</div>
